import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AppSyncService } from 'src/app/core/appsync.service';
import { PatientPortalService } from 'src/app/patient-portal/patient-portal.service';

@Injectable({
  providedIn: 'root'
})
export class PatientPortalAuthGuard implements CanActivate {

  constructor(private patientPortalService: PatientPortalService, private appSyncService: AppSyncService, private router: Router) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    this.patientPortalService.setPatientPortalId = route.params.id;

    return !!this.patientPortalService._savedPdfLink || this.router.createUrlTree(['patient-portal', route.params.id, 'verify']);
  }




  public checkPortalVerification(id: string): Observable<any> {
    return this.appSyncService.hydrated().pipe(
      switchMap(patientPortal =>
        patientPortal.query({
          query: gql(this.getPatientPortalQuery()),
          variables: { id: id }
        })
      ),
      map((result: any) => console.log(result))
    )
  }


  private getPatientPortalQuery() {
    return `query GetPatientPortalGrant($id: ID!) {
      getPatientPortalGrant(id:$id) {
        id
      }
    }`
  }

}



